'use client';
import styled from 'styled-components';
import { MOBILE_VIEWPORT_QUERY } from '@/shared/hooks/useIsMobile';
import { TabHeader, Title, WinList } from '../../styles';

export const NoLineHeightTitle = styled(Title)`
  line-height: 0;
  height: 34px;

  @media ${MOBILE_VIEWPORT_QUERY} {
    height: 24px;
  }
`;
export const NoLineHeightTabHeader = styled(TabHeader)`
  line-height: 0;
`;
export const NoLineHeightWinList = styled(WinList)`
  line-height: 0;
`;
